document.addEventListener('DOMContentLoaded', function () {
  function addCustomStylesToShadowRoot() {
    const el = document.querySelector('#app-embed');
    if (el && el.shadowRoot) {
      // Create a <style> element
      const style = document.createElement('style');
      style.textContent = `

       ._formHeader_1ll8d_19 {
          display: none;
        }

      ._formFieldContainer_1ydxd_5:focus-within ._formInputFieldLabel_1ydxd_37 {
      transform: none!important;
      }

      @media screen and (max-width: 551px) {
      ._inline_stahb_47 ._formContainer_stahb_30 {
          min-width: 300px!important;
      }
      }

      @media screen and (max-width: 767px) {
      form._formFieldset_1ll8d_67 {
      padding-top: 1rem!important;
      }


      }

       @media screen and (min-width: 768px) {

          ._inline_stahb_47 ._formContainer_stahb_30 {
          max-width: 90%!important;
        }  

        ._formFieldContainer_1ydxd_5:nth-child(5) {
        grid-column: 1/3;
        }

        fieldset {
        grid-column: 1/3;
        }

       ._textBody_2aowh_10._radioLegend_nw6va_18 {
        color: #525252!important;
         font-family: 'Adrianna-normal'!important;
        text-transform: capitalize;
        font-size: 16px!important;
        font-weight: bold !important;
        line-height: 1!important;
        margin-bottom: 10px!important;
        padding-left: 10px!important;
       }
  
       button._formSubmitButton_1ll8d_81 {
         font-family: 'Adrianna-normal'!important;
        text-transform: uppercase!important;
        font-size: 18px!important;
        font-weight: bold !important;
        line-height: 1!important;
        padding: 1rem!important;
        width: 80%!important;
       }
        
        form._formFieldset_1ll8d_67 {
          display: grid!important;
          grid-template-columns: 1fr 1fr;
          gap: 44px!important;
        }
       ._formFieldset_1ll8d_67 div {
       flex-direction: column-reverse!important;
       }
       ._formFieldset_1ll8d_67 label {
         position: relative!important;
         top: 0!important;
         left: 0!important;
         color: #525252!important;
         font-family: 'Adrianna-normal'!important;
        text-transform: capitalize;
        font-size: 16px!important;
        font-weight: bold !important;
        line-height: 1!important;
        margin-bottom: 10px!important;
        padding-left: 10px!important;
       }
         ._formFieldset_1ll8d_67 input { 
          border: 1px solid rgba(0, 0, 0, 0.16)!important;
         padding: 0.5rem!important;
        }
     }
      `;
      // Append the <style> element to the shadow root
      el.shadowRoot.appendChild(style);
    } else {
      console.warn('Element with ID "app-embed" or its shadowRoot is not available.');
    }
  }

  const observer = new MutationObserver((mutationsList, observer) => {
    const el = document.querySelector('#app-embed');
    if (el && el.shadowRoot) {
      addCustomStylesToShadowRoot(); // Add custom styles when shadowRoot is available
      observer.disconnect(); // Stop observing
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
});











// document.addEventListener('DOMContentLoaded', () => {

//     function adjustPaginationDots() {
        
//         if (window.innerWidth <= 1022) {
            
//             const titleElement = document.querySelector('.m-richtext__title');
//             const paginationDots = document.querySelector('.swiper-pagination');

//             if (titleElement && paginationDots) {
             
//                 const titleRect = titleElement.getBoundingClientRect();

//                 const bottomPosition = titleRect.bottom + window.scrollY + -18; 

//                 paginationDots.style.position = 'absolute';
//                 paginationDots.style.top = `${bottomPosition}px`;
//             }
//         } else {
      
//             const paginationDots = document.querySelector('.swiper-pagination');
//             if (paginationDots) {
//                 paginationDots.style.position = '';
//                 paginationDots.style.top = '';
//             }
//         }
//     }

    
//     adjustPaginationDots();

 
//     window.addEventListener('resize', adjustPaginationDots);

    
//     const observer = new MutationObserver(adjustPaginationDots);
//     observer.observe(document.body, { childList: true, subtree: true });
// });





const canSectionBottomFooter = document.querySelector('.tcw-can-section-bottom-container-footer');

if (canSectionBottomFooter) {
  const classes = ['active', 'active-1'];
  let currentIndex = 0;

  const updateBackground = () => {
    
    classes.forEach(cls => canSectionBottomFooter.classList.remove(cls));
    canSectionBottomFooter.classList.remove('animate-bg');

    const nextClass = classes[currentIndex];
    canSectionBottomFooter.classList.add(nextClass);

    void canSectionBottomFooter.offsetWidth; 
    canSectionBottomFooter.classList.add('animate-bg');


    currentIndex = (currentIndex + 1) % classes.length;
  };

  setInterval(updateBackground, 1500);
}
















/*Dropdown event type*/
document.addEventListener("DOMContentLoaded", () => {

  const dropdownToggle = document.getElementById("tcw-dropdown-toggle");


  const dropdownContent = document.querySelector(".m-link-lists");

  
  dropdownToggle.addEventListener("click", () => {
    if (dropdownContent.classList.contains("open")) {
      dropdownContent.classList.remove("open");
    } else {
      dropdownContent.classList.add("open");
    }
  });

 
  document.addEventListener("click", (event) => {
    if (!dropdownToggle.contains(event.target) && !dropdownContent.contains(event.target)) {
      dropdownContent.classList.remove("open");
    }
  });
});




